import React from 'react'
import { ResponsiveTableRow } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { formatDate, niceBytes, treeStatusKeyMap } from '../../../helpers'
import GenealogyActions from './GenealogyActions'
import TreeNameOrFileTitle from '../../upload-page/upload-row/TreeNameOrFileTitle'

const GenealogyRow = ({ tree }) => {
  const [t] = useTranslation()
  const { name, createDate, fileSize, treeStatus, personCount } = tree

  return (
    <ResponsiveTableRow
      data-testid={`row_${name}`}
      column1={<TreeNameOrFileTitle name={name} />}
      column2={formatDate(createDate)}
      column3={<div data-testid="personCount">{personCount}</div>}
      column4={<div data-testid="fileSize">{niceBytes(fileSize)}</div>}
      column5={t(treeStatusKeyMap[treeStatus])}
      column6={<GenealogyActions tree={tree} />}
    />
  )
}

export default GenealogyRow
